import { formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, Inject } from '@angular/core'
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material'
import { BaseDialogComponent } from '../../../../../../base/dialog-base/dialog-base.component'
import { NomadeService } from '../../../../../../nomade/services/nomade.service'
import { DialogService } from '../../../../../../services'
import { ONE_MB_IN_BYTES } from '../../../../../../constants/FileSize'
import { environment } from '../../../../../../../environments/environment'



@Component({
	selector: 'atyl-nomade-document-dialog',
	templateUrl: './document-nomade-dialog.component.html',
	styleUrls: ['./document-nomade-dialog.component.scss']
})
export class DocumentDialogComponent extends BaseDialogComponent {

	document: any = { type: null,value: {} };
    typeDocuments: any[]= [];
    totalFilesSize: number = 0;
    limitFileSize: number;
	
	constructor(
		dialogRef: MatDialogRef<DocumentDialogComponent>,
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private nomadeService: NomadeService,
		private snackbar: MatSnackBar
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
        this.limitFileSize = environment.limitFileSize
        if(this.data.document != undefined && this.data.document){
            this.document = this.data.document.document.document;
            this.document.idRequest = this.data.document.idRequest;
        }
        if(this.data.totalFilesSize != undefined && this.data.totalFilesSize){
            this.totalFilesSize = this.data.totalFilesSize;
        }
        this.nomadeService.documentTypes().subscribe(types=>{
            this.typeDocuments = types;
            console.log("DocDialogComponent init",this.data,"doc",this.document,this.typeDocuments)
        });
	}

	uploadFile(event) {
		const element = event[0]
        var checkFileSize = this.checkFileSize(element.size)
		if (checkFileSize.result) {
            console.log(event);
            this.setDocument(element);
		} 
		else {
			this.snackbar.open(checkFileSize.msg, '', {
				duration: 2500,
				panelClass: ['error-snackbar']
			})
		}
	}

    checkFileSize(fsize: any) {
		const fileSizeMb = (fsize / ONE_MB_IN_BYTES);
		if (fileSizeMb > environment.limitFileSize)
			return {result:false,msg:"Le fichier dépasse la limite de taille ("+environment.limitFileSize+" Mo)"};
        else if(this.totalFilesSize + fileSizeMb >= environment.limitTotalFileSize)
            return {result:false,msg:"La limite de "+environment.limitTotalFileSize+" est dépassée ("+
                (environment.limitTotalFileSize-this.totalFilesSize).toFixed(2) + " Mo restants)"};
		else
			return {result:true,msg:null};
	}

    setDocument(file: File){
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.document.value.filename = file.name;
            this.document.value.libelle = file.name;
            this.document.value.base64 = reader.result as string;
            this.document.value.size = file.size;
            this.document.value.dateCreation = new Date();
        };
    }

    compareTypes(type1: any, type2: any): boolean {
        return type1 && type2 ? type1.id === type2.id : false;
    }

}
